import PropTypes from "prop-types"
import { forwardRef } from "react"

import Expand from "components/ui/expand"
import { cn } from "styles/utils"

const variants = {
  hide: {
    right: "-100%",
    transition: { duration: 0.5 },
  },
  show: {
    right: 0,
    transition: { duration: 0.5 },
  },
}

const MobileMenu = forwardRef(({ className, ...props }, ref) => (
  <Expand
    className={cn("side-menu z-40 bg-white", className)}
    ref={ref}
    show
    transition={{ type: "linear" }}
    variants={variants}
    {...props}
  />
))

MobileMenu.displayName = "MobileMenu"

MobileMenu.propTypes = {
  className: PropTypes.string,
}

export default MobileMenu
